import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultPaginationSettings,
  defaultRateLimitationSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { MerakiApiSettingsDefaults } from './types';

export const merakiDefaults: MerakiApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultPaginationSettings,
  ...defaultRateLimitationSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxCapacity: 10,
  refillRate: 10,
};
